"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useIdle = void 0;
const React = __importStar(require("react"));
const utils_1 = require("@icr-ui/utils");
const throttle_debounce_1 = require("throttle-debounce");
const defaultEvents = [
    'mousemove',
    'mousedown',
    'resize',
    'keydown',
    'touchstart',
    'wheel',
];
const oneMinute = 60e3;
function useIdle(ms = oneMinute, initialState = false, events = defaultEvents) {
    const [state, setState] = React.useState(initialState);
    React.useEffect(() => {
        let mounted = true;
        let timeout;
        let localState = state;
        const set = (newState) => {
            if (mounted) {
                localState = newState;
                setState(newState);
            }
        };
        const onEvent = (0, throttle_debounce_1.throttle)(50, () => {
            if (localState) {
                set(false);
            }
            clearTimeout(timeout);
            timeout = setTimeout(() => set(true), ms);
        });
        const onVisibility = () => {
            if (!document.hidden)
                onEvent();
        };
        events.forEach(event => (0, utils_1.on)(window, event, onEvent));
        (0, utils_1.on)(document, 'visibilitychange', onVisibility);
        timeout = setTimeout(() => set(true), ms);
        return () => {
            mounted = false;
            events.forEach(event => (0, utils_1.off)(window, event, onEvent));
            (0, utils_1.off)(document, 'visibilitychange', onVisibility);
        };
    }, [ms, events]);
    return state;
}
exports.useIdle = useIdle;
//# sourceMappingURL=use-idle.js.map